import { Button, ChevronLeft, ChevronRight } from "@repo/ui";

export const TransferButtons = ({
  onMoveToSelected,
  onMoveToAvailable,
  canMoveToSelected,
  canMoveToAvailable,
}: {
  onMoveToSelected: () => void;
  onMoveToAvailable: () => void;
  canMoveToSelected: boolean;
  canMoveToAvailable: boolean;
}) => (
  <div className="flex flex-col gap-2 py-16">
    <Button
      type="button"
      onClick={onMoveToSelected}
      disabled={!canMoveToSelected}
      className="bg-gxe-secondary rounded border p-2 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
    >
      <ChevronRight className="text-gxe-primary h-4 w-4" />
    </Button>
    <Button
      type="button"
      onClick={onMoveToAvailable}
      disabled={!canMoveToAvailable}
      className="bg-gxe-secondary rounded border p-2 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
    >
      <ChevronLeft className="text-gxe-primary h-4 w-4" />
    </Button>
  </div>
);
